import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/home/login.vue'
import store from './store'

Vue.use(Router)

const router = new Router({
  scrollBehavior: () => ({ y: 0 }),
  mode: 'hash',
  base: '/',
  routes: [
    {
      path: '/',
      meta: { title: "登录" },
      component: Home
    },
    {
      path: '/index',
      meta: { title: "首页" },
      component: () => import('./views/home/index.vue')
    },
    {
      path: '/attract/project',
      meta: { title: "项目" },
      component: () => import('./views/attract/project/index.vue'),
      children: [
        {
          path: 'detail',
          component: () => import('@/views/attract/project/detail.vue'),
        }
      ],
    },
    {
      path: '/reallyWillBuy/tour',
      meta: { title: "项目巡览" },
      component: () => import('./views/reallyWillBuy/tour/index.vue'),
      children: [
        {
          meta: {title: '项目巡览'},
          path: 'index',
          component: () => import('@/views/reallyWillBuy/tour/index.vue'),
        },
        
      ],
    },
    {
      path: '/reallyWillBuy/facilities',
      meta: { title: "项目配套" },
      component: () => import('./views/reallyWillBuy/facilities/index.vue'),
      children: [
        {
          meta: {title: '项目配套'}, 
          path: 'index',
          component: () => import('@/views/reallyWillBuy/facilities/index.vue'),
        }
      ],
    },
    {
      path: '/reallyWillBuy/items',
      meta: { title: "预约订单" }, 
      component: () => import('./views/reallyWillBuy/items/index.vue'),
      children: [
        {
          meta: {title: '预约订单'}, 
          path: 'index',
          component: () => import('@/views/reallyWillBuy/items/index.vue'),
        }
      ],
    },
    {
      path: '/reallyWillBuy/Leaseclass',
      meta: { title: "办公分类" },
      component: () => import('./views/reallyWillBuy/Leaseclass/index.vue'),
      children: [
        {
          meta: {title: '办公分类'}, 
          path: 'index',
          component: () => import('@/views/reallyWillBuy/Leaseclass/index.vue'),
        }
      ],
    },
    {
      path: '/reallyWillBuy/officeProducts',
      meta: { title: "办公产品" },
      component: () => import('./views/reallyWillBuy/officeProducts/index.vue'),
      children: [
        {
          meta: {title: '办公产品'}, 
          path: 'index',
          component: () => import('@/views/reallyWillBuy/officeProducts/index.vue'),
        }
      ],
    },
    {
      path: '/reallyWillBuy/enterprise',
      meta: { title: "企业服务" },
      component: () => import('./views/reallyWillBuy/enterprise/index.vue'),
      children: [
        {
          meta: {title: '企业服务'}, 
          path: 'index',
          component: () => import('@/views/reallyWillBuy/enterprise/index.vue'),
        }
      ],
    }, {
      path: '/reallyWillBuy/member',
      meta: { title: "会员福利" },
      component: () => import('./views/reallyWillBuy/member/index.vue'),
      children: [
        {
          meta: {title: '会员福利'}, 
          path: 'index',
          component: () => import('@/views/reallyWillBuy/member/index.vue'),
        }
      ],
    }, {
      path: '/reallyWillBuy/memberorder',
      meta: { title: "会员券码" },
      component: () => import('./views/reallyWillBuy/memberorder/index.vue'),
      children: [
        {
          meta: {title: '会员券码'}, 
          path: 'index',
          component: () => import('@/views/reallyWillBuy/memberorder/index.vue'),
        }
      ],
    }, {
      path: '/reallyWillBuy/shangban',
      meta: { title: "商办资产" },
      component: () => import('./views/reallyWillBuy/shangban/index.vue'),
      children: [
        {
          meta: {title: '商办资产'}, 
          path: 'index',
          component: () => import('@/views/reallyWillBuy/shangban/index.vue'),
        }
      ],
    },
    {
      path: '/attract/house',
      meta: { title: "户型" },
      component: () => import('./views/attract/house/index.vue'),
      children: [
        {
          path: 'detail',
          component: () => import('@/views/attract/house/detail.vue'),
        }
      ],
    },
    {
      path: '/attract/user',
      meta: { title: "用户" },
      component: () => import('./views/attract/user/index.vue'),
      children: [
        {
          path: 'detail',
          component: () => import('@/views/attract/user/detail.vue'),
        }
      ],
    },
    {
      path: '/attract/houseinfo',
      meta: { title: "房源" },
      component: () => import('./views/attract/houseinfo/list.vue'),
      children: [
        {
          path: 'detail',
          component: () => import('@/views/attract/houseinfo/detail.vue'),
        }
      ],
    },
    {
      path: '/attract/banner',
      meta: { title: "广告图" },
      component: () => import('./views/attract/banner.vue'),
    },
    {
      path: '/invest',
      meta: { title: "投资军团" },
      component: () => import('./views/invest/index.vue')
    },
    {
      path: '/setting',
      meta: { title: "设置" },
      component: () => import('./views/setting/index.vue')
    },
    {
      path: '/project/article',
      meta: {title: '文章'},
      component: () => import('./views/project/article/index.vue'),
      children: [
        {
          path: 'pull',
          meta: {title: '拉取'},
          component: () => import('@/views/project/article/set.vue'),
        },
        {
          path: 'changeCity',
          meta: {title: '更改城市'},
          component: () => import('@/views/project/article/changeCity.vue'),
        },
      ],
    },
    {
      path: '/project/official',
      meta: { title: "公众号" },
      component: () => import('./views/project/official/list.vue')
    },
    {
      path: '/project/house',
      meta: {title: '楼盘'},
      component: () => import('./views/project/houses/list.vue'),
      children: [
        {
          path: 'add',
          meta: {title: '新增楼盘'},
          component: () => import('@/views/project/houses/add.vue'),
        },
        {
          path: 'edit',
          meta: {title: '编辑楼盘'},
          component: () => import('@/views/project/houses/edit.vue'),
        },
        {
          path: 'add-house-type',
          meta: {title: '编辑楼盘户型'},
          component: () => import('@/views/project/houses/add-house-type.vue'),
        },
      ],
    },
    {
      path: '/applet/banner',
      meta: {title: '真会投资'},
      component: () => import('./views/applet/banner.vue'),
    },
    {
      path: '/applet/popupad',
      meta: {title: '弹窗广告'},
      component: () => import('./views/applet/pop-up-ad.vue'),
    },
    {
      path: '/applet/question-advertising',
      meta: {title: '问答广告'},
      component: () => import('./views/applet/question-advertising.vue'),
    },
    {
      path: '/applet/invest-banner',
      meta: {title: '投资军团广告图'},
      component: () => import('./views/applet/invest-banner.vue'),
    },
    {
      path: '/applet/advertising',
      meta: {title: '广告位设置'},
      component: () => import('./views/applet/advertising.vue'),
    },
    {
      path: '/applet/member',
      meta: {title: '真会投资--成员管理'},
      component: () => import('./views/applet/member/list.vue'),
      children: [
        {
          path: 'add-type',
          meta: {title: '新增管理员类型'},
          component: () => import('@/views/applet/member/add-type.vue'),
        },
        {
          path: 'edit-type',
          meta: {title: '编辑管理员权限'},
          component: () => import('@/views/applet/member/edit-type.vue'),
        },
        {
          path: 'user',
          meta: {title: '成员管理'},
          component: () => import('@/views/applet/member/user.vue'),
        },
        
      ],
    },
    {
      path: '/project/house-type',
      meta: {title: '楼盘户型'},
      component: () => import('./views/project/house-type/list.vue'),
      children: [
        {
          path: 'edit',
          meta: {title: '编辑户型'},
          component: () => import('@/views/project/house-type/edit.vue'),
        },
      ],
    },
    {
      path: '/project/user',
      meta: {title: '购房顾问'},
      component: () => import('./views/project/user/index.vue'),
      children: [
        {
          path: 'detail',
          component: () => import('@/views/project/user/detail.vue'),
        },
        {
          path: 'team',
          component: () => import('@/views/project/user/team.vue'),
        },
      ],
    },
    {
      path: '/project/city',
      meta: {title: '城市'},
      component: () => import('./views/project/city/cityset.vue'),
    },
    {
      path: '/project/dynamic',
      meta: {title: '城市'},
      component: () => import('./views/project/dynamic/list.vue'),
      children: [
        {
          path: 'add',
          meta: {title: '添加文章'},
          component: () => import('@/views/project/dynamic/add.vue'),
        },
        {
          path: 'edit',
          meta: {title: '添加文章'},
          component: () => import('@/views/project/dynamic/edit.vue'),
        }
      ],
    },
    {
      path: '/project/collect',
      meta: {title: '用户跟进'},
      component: () => import('./views/project/collect/list.vue'),
      children: [
        {
          path: 'follow',
          meta: {title: '跟进'},
          component: () => import('@/views/project/collect/follow.vue'),
        },
        {
          path: 'add',
          meta: {title: '添加客户'},
          component: () => import('@/views/project/collect/add-client.vue'),
        },
      ],
    },
    {
      path: '/invest/tutor',
      meta: {title: '导师团'},
      component: () => import('./views/invest/tutor/list.vue'),
      children: [
        {
          path: 'add',
          meta: {title: '添加导师'},
          component: () => import('@/views/invest/tutor/add.vue'),
        },
        {
          path: 'edit',
          meta: {title: '修改导师信息'},
          component: () => import('@/views/invest/tutor/edit.vue'),
        },
        {
          path: 'case',
          meta: {title: '查看案例'},
          component: () => import('@/views/invest/tutor/case.vue'),
        },
        {
          path: 'recommend',
          meta: {title: '查看案例'},
          component: () => import('@/views/invest/tutor/recommend.vue'),
        },
      ],
    },
    {
      path: '/invest/activity',
      meta: {title: '活动管理'},
      component: () => import("./views/invest/activity/list.vue"),
      children: [
        {
          path: 'add',
          meta: {title: '添加活动'},
          component: () => import('@/views/invest/activity/add.vue'),
        },
        {
          path: 'edit',
          meta: {title: '修改活动'},
          component: () => import('@/views/invest/activity/edit.vue'),
        },
        {
          path: 'apply',
          meta: {title: '报名用户'},
          component: () => import('@/views/invest/activity/apply.vue'),
        },
      ],
    },
    {
      path: '/invest/question',
      meta: {title: '问答'},
      component: () => import("./views/invest/question/list.vue"),
      children: [
        {
          path: 'answer',
          meta: {title: '回答列表'},
          component: () => import('@/views/invest/question/answer.vue'),
        },
      ],
    },
    {
      path: '/invest/survey',
      meta: {title: '问卷调查'},
      component: () => import("./views/invest/survey/survey.vue"),
      children: [
        {
          path: 'detail',
          meta: {title: '回答列表'},
          component: () => import('@/views/invest/survey/survey-detail.vue'),
        },
        {
          path: 'report',
          meta: {title: '回答列表'},
          component: () => import('@/views/invest/survey/survey-report.vue'),
        },
      ],
    },
    {
      path: '/project/stick',
      meta: {title: '楼盘置顶'},
      component: () => import("./views/project/stick/list.vue"),
      children: [
        {
          path: 'answer',
          meta: {title: '回答列表'},
          component: () => import('@/views/invest/question/answer.vue'),
        },
      ],
    },
    {
      path: '/project/home-article',
      meta: {title: '首页资讯'},
      component: () => import("./views/project/home-article/index.vue"),
    },
    {
      path: '/applet/robot',
      meta: {title: '机器人'},
      component: () => import("./views/applet/robot.vue"),
    },
    {
      path: '/project/client',
      meta: {title: '客户'},
      component: () => import("./views/project/client/list.vue"),
      children: [
        {
          path: 'statics',
          meta: {title: '统计'},
          component: () => import('./views/project/client/statistics.vue'),
        },
      ],
    },
    {
      path: '/invest/welfare',
      meta: {title: '金融产品'},
      component: () => import("./views/invest/welfare/list.vue"),
      children: [
        {
          path: 'setuser',
          meta: {title: '设置管理员'},
          component: () => import('./views/invest/welfare/setuser.vue'),
        },
      ],
    },
    {
      path: '/invest/paper',
      meta: {title: '早报'},
      component: () => import("./views/invest/paper/paper-list.vue"),
    },
    {
      path: '/invest/prosperity',
      meta: {title: '喜报'},
      component: () => import("./views/invest/prosperity/prosperity-list.vue"),
    },
    {
      path: '/invest/paper/edit',
      meta: {title: '编辑早报'},
      component: () => import("./views/invest/paper/apper-edit.vue"),
    },
    {
      path: '/invest/foreclosure',
      meta: {title: '法拍房'},
      component: () => import("./views/invest/foreclosure/list.vue"),
      children: [
        {
          path: 'edit',
          meta: {title: '编辑法拍房'},
          component: () => import("./views/invest/foreclosure/edit.vue"),
        },
        {
          path: 'detail',
          meta: {title: '法拍房详情'},
          component: () => import("./views/invest/foreclosure/detail.vue"),
        },
        {
          path: 'dynamic',
          meta: {title: '法拍房动态'},
          component: () => import("./views/invest/foreclosure/dynamic.vue"),
        },
      ],
    },
  ]
})

router.beforeEach((to, from, next) => {
  var user = store.getters.getuser;
  if(!user){
      if (to.path == '/') { //如果是登录页面路径，就直接next()
        next();
      } else { //不然就跳转到登录；
        next('/');
      }
  }
  if (to.meta.title) {//如果设置标题，拦截后设置标题
    document.title = to.meta.title
  }
  next()
})

export default router
